<div class="w-full flex flex-column overflow-hidden flex-1 flex h-full shadow-md surface-ground">
    <div class="flex justify-content-between border-bottom-1 surface-border align-items-center px-4 py-3">
        <p class="h5 font-bold">{{ 'default-admin-filters-list' | translate: 'Custom List' }}</p>

        <button pButton (click)="navigateTo('home/custom-list/edit')">
            <span class="flex align-content-center gap-2">
                <i class="pi pi-plus" pButtonIcon></i>
                <span pButtonLabel>{{ 'default-cm-add' | translate: 'Add' }}</span>
            </span>
        </button>
    </div>
    <div class="flex justify-content-between align-items-center w-full border-bottom-1 surface-border">
        <app-pagination-bar
            class="w-full"
            [(filters)]="filter"
            (filtersChange)="listAllFilters()"
            (pageSizeChange)="listAllFilters()"
            (filtersSearch)="listAllFilters()"
        ></app-pagination-bar>
    </div>
    @if (selectedFilters.length) {
        <div class="h-4rem border-bottom-1 surface-border flex justify-content-start align-items-center px-4 py-3">
            <span class="m-2 text-bold">{{ selectedFilters.length }}</span
            ><span> {{ 'default-cm-selected' | translate: 'Selected' }} </span>
            <p-button
                class="pl-2"
                label="{{ 'default-cm-delete' | translate: 'Delete' }}"
                [text]="true"
                (onClick)="onDelete()"
            ></p-button>
        </div>
    }
    <div class="overflow-scroll h-full">
        <p-table
            styleClass="alpha-border-1 border-x-none border-y-none h-full"
            [scrollable]="true"
            [scrollHeight]="'flex'"
            [value]="adminFilters"
            [(selection)]="selectedFilters"
        >
            <ng-template pTemplate="header">
                <tr class="text-sm">
                    <th><p-tableHeaderCheckbox /></th>
                    <th>
                        <span class="flex">
                            {{ 'default-admin-queue-name' | translate: 'Queue name' }}
                            <span (click)="listAllFilters('filterName')" class="cursor-pointer">
                                @if (!sort['filterName']) {
                                    <img class="ml-2" src="assets/icons/sort-icon.svg" alt="sort" />
                                }
                                @if (sort['filterName'] && sortStatus === 'ASC') {
                                    <img src="assets/icons/sort-asc-icon.svg" alt="sort" />
                                }
                                @if (sort['filterName'] && sortStatus === 'DESC') {
                                    <img src="assets/icons/sort-desc-icon.svg" alt="sort" />
                                }
                            </span>
                        </span>
                    </th>
                    <th>
                        <span class="flex">
                            {{ 'default-cm-description' | translate: 'Description' }}
                            <span (click)="listAllFilters('description')" class="cursor-pointer">
                                @if (!sort['description']) {
                                    <img class="ml-2" src="assets/icons/sort-icon.svg" alt="sort" />
                                }
                                @if (sort['description'] && sortStatus === 'ASC') {
                                    <img src="assets/icons/sort-asc-icon.svg" alt="sort" />
                                }
                                @if (sort['description'] && sortStatus === 'DESC') {
                                    <img src="assets/icons/sort-desc-icon.svg" alt="sort" />
                                }
                            </span>
                        </span>
                    </th>
                    <th>
                        <span class="flex">{{ 'default-admin-filter-queueSouce' | translate: 'Source' }}</span>
                    </th>
                    <th>
                        <span class="flex">{{ 'default-cm-groups' | translate: 'Groups' }}</span>
                    </th>
                    <th>
                        <span class="flex">{{ 'default-cm-users' | translate: 'Users' }}</span>
                    </th>
                    <th>
                        <span class="flex">
                            {{ 'default-cm-createdAt' | translate: 'Created At' }}
                            <span (click)="listAllFilters('createdAt')" class="cursor-pointer">
                                @if (!sort['createdAt']) {
                                    <img class="ml-2" src="assets/icons/sort-icon.svg" alt="sort" />
                                }
                                @if (sort['createdAt'] && sortStatus === 'ASC') {
                                    <img src="assets/icons/sort-asc-icon.svg" alt="sort" />
                                }
                                @if (sort['createdAt'] && sortStatus === 'DESC') {
                                    <img src="assets/icons/sort-desc-icon.svg" alt="sort" />
                                }
                            </span>
                        </span>
                    </th>
                    <th>
                        <span class="flex">
                            {{ 'default-cm-updatedAt' | translate: 'Updated At' }}
                            <span (click)="listAllFilters('updatedAt')" class="cursor-pointer">
                                @if (!sort['updatedAt']) {
                                    <img class="ml-2" src="assets/icons/sort-icon.svg" alt="sort" />
                                }
                                @if (sort['updatedAt'] && sortStatus === 'ASC') {
                                    <img src="assets/icons/sort-asc-icon.svg" alt="sort" />
                                }
                                @if (sort['updatedAt'] && sortStatus === 'DESC') {
                                    <img src="assets/icons/sort-desc-icon.svg" alt="sort" />
                                }
                            </span>
                        </span>
                    </th>
                    <th>
                        <span class="flex">{{ 'default-cm-action' | translate: 'Action' }}</span>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-row let-index="rowIndex">
                <tr class="font-normal text-md cursor-pointer">
                    <td>
                        <p-tableCheckbox [value]="row" />
                    </td>
                    <td>{{ row.filterName }}</td>
                    <td>{{ row.description }}</td>
                    <td>
                        {{ inboxConfig[row.inboxListType]?.lang | translate: inboxConfig[row.inboxListType]?.label }}
                    </td>

                    <td class="gap-2 white-space-nowrap">
                        {{ (row.groups | slice: 0 : 2 | join: 'groupName') || '-' }}
                        @if (row.groups?.length > 2) {
                            <span
                                class="border-1 surface-border border-circle p-1 ml-1"
                                [pTooltip]="tooltipContent"
                                tooltipPosition="bottom"
                                >+{{ row.groups.length - 2 }}</span
                            >
                        }
                        <ng-template #tooltipContent>
                            <div class="flex align-items-center">
                                {{ row.groups | slice: 2 | join: 'groupName' }}
                            </div>
                        </ng-template>
                    </td>

                    <td class="gap-2 white-space-nowrap">
                        <span [pTooltip]="userTooltipContent" tooltipPosition="bottom">
                            {{ row.users?.length || 0 }}
                        </span>
                        <ng-template #userTooltipContent>
                            <div class="flex align-items-center">
                                {{ row.users || [] | join: 'userName' }}
                            </div>
                        </ng-template>
                    </td>

                    <td>{{ row.metadata.createdAt | date: 'short' }}</td>
                    <td>{{ row.metadata.updatedAt | date: 'short' }}</td>

                    <td class="pl-4 p-2">
                        <span
                            (click)="openToggleMenu(action, adminFilters[index], $event)"
                            class="flex align-items-center justify-content-start border-round-sm p-1 width-20 padding-py-10 hover:bg-white hover:text-primary-700"
                        >
                            <i class="pi pi-ellipsis-v w-full h-full"></i>
                        </span>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="100%">
                        <div class="flex flex-column justify-content-center align-items-center gap-2">
                            <img class="w-15rem p-3" src="assets/images/no-filter.svg" alt="" />
                            <span class="text-color-secondary">{{
                                'default-admin-filters-no-customList' | translate: 'No Custom list Yet'
                            }}</span>
                            <span
                                class="text-bold cursor-pointer text-primary-700"
                                (click)="navigateTo('home/custom-list/edit')"
                                >{{
                                    'default-admin-filters-add-newCustomList' | translate: 'Add New Custom List'
                                }}</span
                            >
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<p-menu
    #action
    [model]="actionsOptions"
    [popup]="true"
    styleClass="w-8rem p-0 cursor-pointer hover:surface-hover shadow-md"
>
    <ng-template pTemplate="item" let-action>
        <div class="flex w-2rem cursor-pointer gap-1 align-items-center py-3 px-3">
            <img [src]="action.icon" height="15" alt="-" />
            <span class="font-normal line-height-1">{{ action.label | translate }}</span>
        </div>
    </ng-template>
</p-menu>
